/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { HOST } from "./../../config";
import SemesterName from "./SemesterName";
import "./StudentKomp.css";

class StudentKomp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // PhFSp: [],
      ORDERS: [],
      year: "",
      fio: "",
      dopusk: "",
    };
  }

  componentDidMount() {
    fetch(`${HOST}/data.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.props.id_student,
        gid: this.props.id_group,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          // PhFSp: json.PhFSp[0].v2,
          fio: json.PhFSp[0].s_fio,
          group: json.PhFSp[0].groups,
          s_id: json.PhFSp[0].idid,
        });
      });

    fetch(`${HOST}/dopusk.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: this.props.id_student,
        idGroup: this.props.id_group,
        idYear: this.props.YEAR,
        idWS: this.props.id_ws,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.result === 200)
          this.setState({
            dopusk: json.data ? json.data.dopusk : " - ",
          });
      });

    this.setState({
      PAYMENT: this.props.PAYMENT,
      // CorrYear: this.props.YEAR,
      // coryear: `20${this.props.YEAR}-${this.props.YEAR + 1}`,
      // corsem: SemesterName(this.props.ws),
      photo: JSON.parse(localStorage.getItem("image")),
    });
  }

  render() {
    const Payment = this.props.PAYMENT;

    let Photo = [];
    let OplataShort = [];

    if (Payment) {
      if (Payment[0]) {
        OplataShort.push(
          <div>
            <h3>
              Контракт:{" "}
              <span>{Payment[0][Payment[0].length - 1].smeta} сом</span>
            </h3>
            <h3>
              Оплатил:{" "}
              <span>{Payment[0][Payment[0].length - 1].sum_opl} сом</span>
            </h3>
            <h4>
              Долг: <span>{Payment[0][Payment[0].length - 1].dolg} сом</span>
            </h4>
            <h4>
              Допуск: <span>{this.state.dopusk}</span>
            </h4>
            <h3>
              <span>{Payment[0][Payment[0].length - 1].spec1} </span>
            </h3>
          </div>
        );
      }
    }
    // else {
    //   OplataShort.push(
    //     <div>
    //       <h3>Бюджет</h3>
    //     </div>
    //   )
    // }

    if (this.state.photo)
      Photo.push(<img src={`data:image/jpeg;base64,${this.state.photo}`} />);
    else {
      Photo.push(<img src="/lms/public/img/avatar.png" alt="if-empty-name1" />);
    }

    ////////////////////////////////////////////////////////////////////////////////
    return (
      <div>
        <div className="St_cont_main">
          <div className="St_container">
            <div className="St_Photo">{Photo}</div>
            <div className="St_fio_container">
              <h1>{this.state.fio}</h1>
              <h2 className="St_gr">{this.state.group}</h2>
              <h2 className="St_id">{this.state.s_id}</h2>
              <div className="corr_y_s">
                <h2 className="St_coryear">{`20${this.props.YEAR}-${
                  this.props.YEAR + 1
                } - учебный год`}</h2>
                <h2 className="St_corsem">{SemesterName(this.props.ws)}</h2>
              </div>
            </div>
          </div>
          <div className="OplataShort">{OplataShort}</div>
        </div>
      </div>
    );
  }
}

export default StudentKomp;
